import { useEngineModeSignal } from '../../../rx/signal/useEngineModeSignal'
import createEngineRoot from './createEngineRoot'
import { EngineMode } from './EngineMode/EngineMode.enum'
import { getDefaultStateMapDisk } from '../state/getDefaultStateMapDisk'

// placeholder for declaring intent
const createEngineForArmyPainter = function () {
  const engine = createEngineRoot(getDefaultStateMapDisk())
  const [, setEngineMode] = useEngineModeSignal(engine)
  setEngineMode(EngineMode.ArmyPainter)
  return engine
}

export default createEngineForArmyPainter
